import gql from 'graphql-tag';

export const MEMBER_CASCADE_DATA =gql`
query contributors($okr_Duedate_Range: [DateTime],$employee:ID,$createdBy_Ne:ID,$offset:Int,$first:Int){
    AllCascadingObjectives:contributors(okr_Duedate_Range: $okr_Duedate_Range,role_In: ["COLLABORATOR", "ASSIGNED"], employee:$employee, createdBy_Ne:$createdBy_Ne,offset:$offset,first:$first) {
		    totalCount
        edgeCount
        edges {
            node {
                id
                progress
                okrType
                okr{
                    id
                    duedate
                    title
                    okrType
                    isDiscarded{
                        id
                    }
                    discardRequest(status:"PENDING") {
                      edges {
                        node {
                          id
                          status
                        }
                      }
                    }
                    contributorSet {
                        edges {
                          node {
                            id
                            employee {
                              id
                              user{
                                id
                              }
                            }
                            requestStatus
                          }
                        }
                    }
                }
            }
        }
    }
}
`